<template>
  <div class="container">
    <h3>{{ $t('bookings.confirmed_title') }}</h3>
    <p v-if="isTheater === false">{{ $t('bookings.confirmed_info', {minutes: 15}) }}</p>
    <p v-if="isTheater === true">{{ $t('bookings.confirmed_theater_info') }}</p>
  </div>
  <div class="actions">
    <router-link class="next" to="/planning">{{ $t('bookings.finish') }}</router-link>
  </div>
</template>

<script>
export default {
  name: "Finalize",
  data() {
    return {
      isTheater: null
    }
  },
  async mounted() {
    if (!this.$route.params.id) {
      this.$toast.error(this.$t('bookings.errors.unknown_activity'));
      this.$router.push('/planning')
    }

    const show = await this.$api.shows.byId(this.$route.params.id)

    // Theatre
    this.isTheater = show.salle === 36;
  }
}
</script>

<style scoped>
.actions {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 10px 20px;
}

.container {
  margin: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 6px;
}

h3 {
  color: #7d06a6;
  margin: 0;
}

p{
  color: black;
}

</style>